import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons";
import {
  faBoxesStacked,
  faPalletBox,
  faStopwatch,
  faTruck,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Card, Progress, Tooltip } from "antd";
import ReactCountryFlag from "react-country-flag";
import { getVesselColourClasses } from "../../helpers/common";
import dayjs, { fromUtc } from "../../helpers/dayjsSetup";

const VesselCard = ({ vessel, isDragging }) => {
  const { containerNum, type, vesselName, supplierShortCode, userReference, contents, boxes, boxesUnloadManHours, pallets, palletsUnloadManHours, containerProgress, statusName, isDeliveryBooked, isDeliveryConfirmed, notes, isAlertActive, alertDate, alertNote, alertUserName, deliveryDate, deliveryMethod, pol, pod, containerLoadType, warehouseDetail } = vessel;
  const { bg, text } = getVesselColourClasses(vesselName);
  return (
    <Tooltip
      title={
        notes && (
          <div className="line-clamp-4 overflow-hidden text-ellipsis text-[14px] text-[#1E1E1E]">
            {notes}
          </div>
        )
      }
      placement="top"
      color="lightyellow"
    >
      <Card
        style={{
          opacity: isDragging ? 0.5 : 1,
          marginBottom: 4,
          cursor: isDragging ? "grab" : "pointer",
          overflow: "hidden",
          width: "144px",
          border: "1px solid #C4C3C3",
          boxShadow: "0px 2px 2px rgba(0,0,0,0.25)",
        }}
        styles={{ body: { padding: 0 } }}
      >
        <div>
          <div className="p-[4px] mb-[4px]">
            <div className="text-[16px] text-[#1E1E1E] font-medium">
              {containerNum}
            </div>
            <div
              className={`w-fit text-[12px] ${text} font-semibold ${bg} rounded-lg px-[4px] mb-[2px]`}
            >
              {vesselName}
            </div>
            <div className="text-[11px] text-[#545454] font-medium flex justify-between leading-none mt-[4px] mb-[1px]">
              <span>{supplierShortCode}</span>
              <span>{userReference}</span>
            </div>
            <div className="text-[12px] text-[#545454] font-medium">
              {contents}
            </div>
            <hr className="border-t border-[#F2F2F2] my-[4px]" />
            <div className="text-[11px] text-[#545454] font-medium flex justify-between items-center leading-none mt-[4px]">
              <span className="text-[14px] text-[#1E1E1E] font-medium">
                {statusName}
              </span>
              {isAlertActive && (
                <Tooltip
                  title={
                    <div>
                      <div className="text-[14px] text-[#1E1E1E] font-semibold whitespace-nowrap">
                        {fromUtc(alertDate).format("ddd DD MMM YYYY")}{" "}
                        {alertUserName}
                      </div>
                      <div className="text-[14px] text-[#545454] line-clamp-3 overflow-hidden text-ellipsis">
                        {alertNote}
                      </div>
                    </div>
                  }
                  placement="bottom"
                  color="white"
                >
                  <FontAwesomeIcon
                    icon={faCircleExclamation}
                    color="#F24405"
                    className="mr-[2px] text-[14px]"
                  />
                </Tooltip>
              )}
            </div>
            <div className="flex items-center justify-between my-[2px]">
              <div className="font-medium flex items-center">
                <ReactCountryFlag
                  countryCode={pol?.substring(0, 2)}
                  svg
                  className="!w-4 !h-4"
                />
              </div>
              <Progress
                percent={containerProgress}
                showInfo={false}
                size={{ height: 4 }}
                strokeColor="#545454"
                trailColor="#E0E0E0"
                className="flex items-center self-center mx-[4px]"
              />
              <div className="font-medium flex items-center">
                <ReactCountryFlag
                  countryCode={pod?.substring(0, 2)}
                  svg
                  className="!w-4 !h-4"
                />
              </div>
            </div>
            <div className="text-[12px] text-[#555555] font-bold leading-none flex justify-between items-start">
              <span>
                {boxes !== null && boxes !== undefined && boxes !== 0 && (
                  <span className="mr-[4px] text-[9px] text-[#2a1313]">
                    <FontAwesomeIcon icon={faBoxesStacked} />
                    <span className="text-[12px] text-[#545454] font-medium font-inter">
                      &nbsp;{boxes}
                    </span>
                  </span>
                )}
                {pallets !== null && pallets !== undefined && pallets !== 0 && (
                  <span className="mr-[4px] text-[9px] text-[#545454]">
                    <FontAwesomeIcon icon={faPalletBox} />
                    <span className="text-[12px] text-[#545454] font-medium font-inter">
                      &nbsp;{pallets}
                    </span>
                  </span>
                )}
                {((boxesUnloadManHours !== null &&
                  boxesUnloadManHours !== undefined &&
                  boxesUnloadManHours !== 0) ||
                  (palletsUnloadManHours !== null &&
                    palletsUnloadManHours !== undefined &&
                    palletsUnloadManHours !== 0)) && (
                  <span className="text-[9px] text-[#545454]">
                    <FontAwesomeIcon icon={faStopwatch} />
                    <span className="text-[12px] text-[#545454] font-medium font-inter">
                      &nbsp;{boxesUnloadManHours + palletsUnloadManHours}
                    </span>
                  </span>
                )}
              </span>
              <span className="text-[11px] text-[#545454] font-medium mt-[1px]">{containerLoadType === "LCL" ? containerLoadType : type}</span>
            </div>
            <div className="text-[11px] text-[#545454] font-medium leading-none mt-[4px]">
              <span>{warehouseDetail?.warehouseShortCode}</span>
            </div>
          </div>
          {deliveryDate && (
            <div className="bg-[#EFEFEF] p-[4px]">
              <div className="text-[14px] text-[#545454] leading-none mb-[2px]">
                {deliveryMethod}
              </div>
              <div className="flex justify-between items-center leading-none">
                <span className="text-[12px] text-[#1E1E1E] font-medium">
                  {dayjs(deliveryDate).format("HH:mm")}
                </span>
                {isDeliveryConfirmed ? (
                  <FontAwesomeIcon
                    icon={faTruck}
                    color="#14AE5C"
                    className="h-[12px]"
                  />
                ) : isDeliveryBooked ? (
                  <FontAwesomeIcon
                    icon={faTruck}
                    color="#F24405"
                    className="h-[12px]"
                  />
                ) : null}
              </div>
            </div>
          )}
        </div>
      </Card>
    </Tooltip>
  );
};

export default VesselCard;
